import { styled } from "@mui/material";
export const Section = styled('section')(({ theme }) => (props) => ({
    padding: '24px  96px  ',
    marginBottom: '25vh',
    [theme.breakpoints.down('md')]: {
        padding: '24px  48px  '
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px  24px  ',
        marginBottom: '30px'
    },
    [theme.breakpoints.down('xs')]: {
        padding: '6px 12px  '
    },
}))
export const TextSection = styled('div')(({ theme }) => (props) => ({
    background: '#0056D21A',
    height: '100px'
}))
export const ImageSection = styled('div')(({ theme }) => (props) => ({
    position: 'relative',
    width: '210px',
    zIndex: '2',
    [theme.breakpoints.down('sm')]: {
        width: '60px',
    }
}))
export const Image = styled('img')(({ theme }) => (props) => ({
    width: props.width,
    height: props.height,
    borderRadius: '5px',
    [theme.breakpoints.down('sm')]: {
        width: '60px',
    },
    [theme.breakpoints.down('xs')]: {
        width: '60px',
        height: '65px'
    }
}))
export const Heading = styled('h5')(({ theme }) => (props) => ({
    fontSize: '24px',
    fontWeight: 800,
    lineHeight: '29px',
    letterSpacing: '0em',
    margin: '0 0 10px',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    [theme.breakpoints.down('sm')]: {
        lineHeight: '10px',
    }
}))
export const SubHeading = styled('h6')(({ theme }) => (props) => ({
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '24.5px',
    letterSpacing: '0em',
    margin: '0 0 12px',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary
}))
export const Discretion = styled('p')(({ theme }) => (props) => ({
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '21px',
    letterSpacing: '0em',
    width: '80%',
    minWidth: '80%',
    color: theme.palette.mode === 'light' ? theme.palette.text.light : theme.palette.text.dark,
    [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
        lineHeight: '16px',
        width: '95%',
    }
}))
export const Hr = styled('hr')(({ theme }) => (props) => ({
    width: props.width ? props.width : '100%',
    height: props.height ? props.height : '1px',
    background: props.background ? props.background : ' #0056D2',
    border: 'none',
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    }
}))
export const BackGround = styled('div')(({ theme }) => (props) => ({
    background: ' #0056D21A',
    position: 'absolute',
    left: "-300px",
    padding: '0  0 0 300px ',
    borderRadius: "5px",
    minWidth: '100%',
    [theme.breakpoints.down('sm')]: {
        left: "0",
        padding: '8px ',
        position: 'static',
    },
}))
